var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrophy8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 134.899,
    height: 223.371,
    viewBox: "0 0 134.899 223.371",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trophy_8_",
    "data-name": "trophy (8)",
    transform: "translate(-101.395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49013",
    "data-name": "Path 49013",
    d: "M241,228.041h13.09v44.518H241Z",
    transform: "translate(-78.698 -128.553)",
    fill: "#e2d9fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49014",
    "data-name": "Path 49014",
    d: "M256,228.041h6.545v44.518H256Z",
    transform: "translate(-87.155 -128.553)",
    fill: "#c7c1dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49015",
    "data-name": "Path 49015",
    d: "M153.909,313.808h89.518v79.947H153.909Z",
    transform: "translate(-29.604 -176.903)",
    fill: "#f2f2fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49016",
    "data-name": "Path 49016",
    d: "M245.334,390.415l-9.779-3.115-9.779,3.115-.059-10.262-5.984-8.337,9.742-3.227,6.08-8.269,6.08,8.269,9.742,3.227-5.984,8.337Z",
    transform: "translate(-66.711 -203.123)",
    fill: "#e2d9fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49017",
    "data-name": "Path 49017",
    d: "M153.909,313.808h89.518v79.947H153.909Z",
    transform: "translate(-29.604 -176.903)",
    fill: "#f2f2fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49018",
    "data-name": "Path 49018",
    d: "M256,313.808h44.978v79.947H256Z",
    transform: "translate(-87.155 -176.903)",
    fill: "#e2d9fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49019",
    "data-name": "Path 49019",
    d: "M387.816,495.154V482.117",
    transform: "translate(-161.464 -271.783)",
    fill: "#c7c1dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49020",
    "data-name": "Path 49020",
    d: "M123.517,482.117h115.6v13.037h-115.6Z",
    transform: "translate(-12.471 -271.783)",
    fill: "#e2d9fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49021",
    "data-name": "Path 49021",
    d: "M313.508,482.117H256v13.037h57.507",
    transform: "translate(-87.155 -271.783)",
    fill: "#c7c1dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49022",
    "data-name": "Path 49022",
    d: "M245.334,390.415l-9.779-3.115-9.779,3.115-.059-10.262-5.984-8.337,9.742-3.227,6.08-8.269,6.08,8.269,9.742,3.227-5.984,8.337Z",
    transform: "translate(-66.711 -203.123)",
    fill: "#00d7df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49023",
    "data-name": "Path 49023",
    d: "M262.08,368.589,256,360.32V387.3l9.779,3.115.059-10.262,5.984-8.337Z",
    transform: "translate(-87.155 -203.123)",
    fill: "#00b2cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49024",
    "data-name": "Path 49024",
    d: "M168.845,108.472,101.4,45.048,119.509,0H218.18l18.114,45.048Z",
    transform: "translate(0)",
    fill: "#00d7df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49025",
    "data-name": "Path 49025",
    d: "M256,108.472V0h49.335L323.45,45.048Z",
    transform: "translate(-87.155)",
    fill: "#00b2cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49026",
    "data-name": "Path 49026",
    d: "M226.447,166.681l-22.872-63.424h45.743Z",
    transform: "translate(-57.602 -58.209)",
    fill: "#0f9dce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49027",
    "data-name": "Path 49027",
    d: "M101.395,45.048,119.442,0l26.464,45.048Z",
    transform: "translate(0)",
    fill: "#00b2cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49028",
    "data-name": "Path 49028",
    d: "M204.147,45.048,226.769,0,249.64,45.048Z",
    transform: "translate(-57.924)",
    fill: "#00b2cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49029",
    "data-name": "Path 49029",
    d: "M256,166.681V103.257h22.872Z",
    transform: "translate(-87.155 -58.209)",
    fill: "#00d7df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49030",
    "data-name": "Path 49030",
    d: "M256,45.048V0l22.872,45.048Z",
    transform: "translate(-87.155)",
    fill: "#0f9dce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49031",
    "data-name": "Path 49031",
    d: "M308.425,45.048,334.732,0l17.539,45.048Z",
    transform: "translate(-116.709)",
    fill: "#00d7df"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy8);
export default __webpack_public_path__ + "static/media/trophy_8.25d5a314bf89f9bdb6cec8a8a06ba40e.svg";
export { ForwardRef as ReactComponent };